import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export const showConfirm = async (title, text, confirmButtonText = 'Yes', cancelButtonText = 'No') => {
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#00C853',
    cancelButtonColor: '#1B5E20',
    confirmButtonText,
    cancelButtonText,
  });
  return result.isConfirmed;
};

export const showSuccess = (title, text) => {
  Swal.fire({
    title,
    text,
    icon: 'success',
    confirmButtonColor: '#00C853',
  });
};

export const showInfo = (title, text) => {
  Swal.fire({
    title,
    text,
    icon: 'info',
    confirmButtonColor: '#00C853',
  });
}; 